<template src="./template/slip-info-modal.html"> </template>

<script>
export default {
  name: "ModalSlipInfo",
  props: {
    info: Object,
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },
    getLabel(value) {
      if (value) return "Yes";
      return "No";
    },
  },
};
</script>

<style lang="scss">
#modalEditBanner {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: transparent;
  transition: opacity 0.15s linear;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  .modal-form {
    display: flex;
    height: auto;
    align-items: center;
    .content {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 8px;
      width: 100%;
      .title {
          font-size: 14px;
          margin: 0;
          margin-right: 10px;
      }
    }
  }
  button {
      float: right;
  }
}
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>
